import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { buildLangPath } from "@/utils/routeBuilders";
import { getDefaultLangFromHostname } from "@/utils/getDefaultLangFromHostname";
import type { Lang } from "@/i18n/languages";

export default function RedirectToLang() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const defaultLang: Lang = getDefaultLangFromHostname(window.location.hostname);

    const target = `${buildLangPath(defaultLang, "/")}${location.search || ""}${location.hash || ""}`;
    navigate(target, { replace: true });
  }, [location.search, location.hash, navigate]);

  return null;
}
